<div class="page-container">
	<h4 class="qo-padding20 medium head-title">{{ data.likes | i18nPlural: {
		'=1': 'MESSAGE_BOARD.LIKES.SINGLE',
		'other': 'MESSAGE_BOARD.LIKES.PLUR'
	} | translate:{x: data.likes} }}</h4>
	<div class="line"></div>

	<div class="likes-holder">
		<div
			class="like"
			[class.selected]="i %2 === 1 && i > 0"
			[class.margin-bottom140]="!(pagination?.total > (postLikesInfo$ | async)?.length) && i === (postLikesInfo$ | async).length -1"
			*ngFor="let like of (postLikesInfo$ | async); let i = index; trackBy: trackByIndex"
		>
			<div class="user-profile">
				<div class="holder-image">
					<div class="profile-picture">
						<qo-profile-image
							[imageUrl]="like.user.profile_picture ?.download_url"
							[letter]="like.user.getInitials()"
							[size]="40"
							[fontSize]="20"
						></qo-profile-image>
					</div>
				</div>
				<div class="user-name">
					{{like.user.getFullName()}}
				</div>
			</div>
		</div>
		<div
			class="qo-margin-top15 center margin-bottom140"
			*ngIf="pagination?.total > (postLikesInfo$ | async)?.length && !data.punchClock"
			(click)="loadMore()"
		>
			<button class="qo-button-small qo-secondary">{{'GLOBAL.LOAD_MORE' | translate}}</button>
		</div>
	</div>

	<div class="qo-flex-row-bottom-right qo-padding20 qo-margin-top20 action-button">
		<button class="qo-button-standard qo-grey" (click)="close()">{{'GLOBAL.CLOSE' | translate}}</button>
	</div>
</div>

